import { SpaceBetween, Spinner } from "@amzn/awsui-components-react";
import { getString } from "common";
import VerticalDividerLine from "common/DividerLine/VerticalDividerLine";
import { useGetOrder } from "hooks";

export interface OrderDetailsContentHeaderProps {
    data: any,
    error: any,
    isLoading: boolean,
    stringPath: string,
    isAmznham: boolean,
    amznhamOrder: ReturnType<typeof useGetOrder>
}

export const OrderDetailsContentHeader = (props: OrderDetailsContentHeaderProps): JSX.Element => {
    const showIfReady = (tab: JSX.Element) => props.isLoading ? <Spinner data-testid="spinner" /> : tab;

    const getPageTitle = (): JSX.Element =>{
        let header: JSX.Element;
        if (props.error || !props.data) {
            header =  <span data-testid="order-details-not-found">{getString("notFound.title", props.stringPath)}</span>
        } else if (props.isAmznham) {
            const hopOrderId = (props.amznhamOrder.data?.details as any)?.hopOrderIds?.[0]
            header = (
            <>
                <span data-testid="ham-order-id">{getString("headerTitleHam", props.stringPath)} {props.data?.orderReference ?? ""}</span>
                {!!props.amznhamOrder.data &&
                <>
                    <VerticalDividerLine />
                    <span data-testid="shop-order-id">{getString("headerTitleShop", props.stringPath)} {props.amznhamOrder.data?.orderReference}</span>
                    <VerticalDividerLine />
                    <span data-testid="shop-order-status">{getString("headerTitleShopStatus", props.stringPath)} {props.amznhamOrder.data?.status ?? ""}</span>
                </>
                }
                {hopOrderId &&
                <>
                    <VerticalDividerLine />
                    <span data-testid="hop-order-id">{getString("headerTitleHop", props.stringPath)} {(props.amznhamOrder.data?.details as any)?.hopOrderIds?.[0] ?? ""}</span>
                </>
                }
            </>
            )
        } else {
            header = <span data-testid="ham-order-id">{getString("headerTitle", props.stringPath)} {props.data?.orderReference ?? ""}</span>
        }
        return header;
    }

    return (
        <SpaceBetween direction="horizontal" size="xxl">
            {showIfReady(getPageTitle())}
        </SpaceBetween>
    );
};
